export const MOBILE = 'MOBILE';
export const DESKTOP = 'DESKTOP';

// RESOLVE: maybe for future somethings like that
/*DEVICES:{
  MOBILE:{
    ANDROID:{
      RESOLUTION:{},
      PORTRAIT:{},
    },
    IPHONE:{
      RESOLUTION:{},
      PORTRAIT:{},
    }
  }
}*/
